'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./StatisticsReminders.scss');

var sendTypes = { remind: 'remind', all: 'all' };

var StatisticsReminders = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sendRemindersActionData: state.statistics.sendRemindersActionData,
    sendRemindersLoading: state.statistics.sendRemindersLoading
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(StatisticsReminders, _Component);

  function StatisticsReminders() {
    (0, _classCallCheck3.default)(this, StatisticsReminders);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsReminders.__proto__ || (0, _getPrototypeOf2.default)(StatisticsReminders)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsReminders, [{
    key: 'send',
    value: function send(_ref) {
      var sendType = _ref.sendType;
      var _props = this.props,
          sendReminders = _props.sendReminders,
          projectId = _props.projectId;
      var t = this.context.t;


      return sendReminders({ projectId: projectId, sendType: sendType }).promise.then(function (resp) {
        _toastr2.default.info(t('Reminders sent'));
        return resp;
      }).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'sendReminders',
    value: function sendReminders() {
      this.send({ sendType: sendTypes.remind });
    }
  }, {
    key: 'sendToAll',
    value: function sendToAll() {
      this.send({ sendType: sendTypes.all });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          sendRemindersLoading = _props2.sendRemindersLoading,
          sendRemindersActionData = _props2.sendRemindersActionData;
      var t = this.context.t;

      var isSendRemindersLoading = sendRemindersLoading && sendRemindersActionData.sendType === sendTypes.remind;
      var isSendToAllLoading = sendRemindersLoading && sendRemindersActionData.sendType === sendTypes.all;

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.container, className) },
        _react2.default.createElement(
          _Button2.default,
          { className: 'btn-primary', onClick: this.sendReminders, loading: isSendRemindersLoading },
          t('Send reminders')
        ),
        _react2.default.createElement(
          _Button2.default,
          { className: 'btn-primary', onClick: this.sendToAll, loading: isSendToAllLoading },
          t('Send to all recipients')
        )
      );
    }
  }]);
  return StatisticsReminders;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  projectId: _propTypes2.default.number,
  sendReminders: _propTypes2.default.func,
  sendRemindersActionData: _propTypes2.default.object,
  sendRemindersLoading: _propTypes2.default.bool
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  onClick: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'sendReminders', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'sendReminders'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'sendToAll', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'sendToAll'), _class2.prototype)), _class2)) || _class);
exports.default = StatisticsReminders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/StatisticsReminders/StatisticsReminders.js
// module id = 2225
// module chunks = 1